/**
 * Abstract base class for localized forecasts.
 */
export class ForecastDefault {
    /**
     * Constructs a localized forecast implementation.
     *
     * @param localizationParameters Provides localization standard parameters for the implemented market.
     */
    constructor(localizationParameters) {
        this.localizationParameters = localizationParameters;
    }
    /**
     * Makes a post calculations update on input data to prepare for next years forecast to update basic data such as age, income and
     * applies localizationparameters.
     *
     * @param input The input data to apply the update to (the last month of the year)
     * @param result The calculated result from the current month
     * @param callback A callback to provide further updates that is not covered by the generic update, for example
     * local market amortization parameters etc.
     */
    updateYearlyInputData(input, result, callback) {
        /* eslint-disable no-param-reassign */
        if (input.children) {
            for (const child of input.children) {
                child.age += 1;
            }
        }
        if (input.adults) {
            for (const adult of input.adults) {
                adult.age += 1;
                adult.income = Math.round(adult.income * adult.employmentRate * this.localizationParameters.household.estimatedSalaryIncreaseFactor);
            }
        }
        if (callback) {
            callback(input, result);
        }
    }
    /**
     * Makes a post calculations update on input data to prepare for next month forecast to update basic data such as loan amount, account balance
     * and applies localizationparameters.
     *
     * @param input The input data to apply the update to (the last month)
     * @param result The calculated result from the current month
     * @param callback A callback to provide further updates that is not covered by the generic update, for example
     * local market amortization parameters etc.
     */
    // eslint-disable-next-line class-methods-use-this
    updateMonthlyInputData(input, result, callback) {
        if (input.savings) {
            input.savings.forEach((saving, index) => {
                saving.amount = result.savings[index].balance;
            });
        }
        if (input.privateLoans) {
            input.privateLoans.forEach((loan, index) => {
                loan.amount = result.privateLoans[index].amount - result.privateLoans[index].amortization;
            });
        }
        if (callback) {
            callback(input);
        }
    }
}
